export {
    default as IconsLinksList,
    type IconsLinksListProps,
} from './IconsLinksList';
